import ScrollReveal from './ScrollReveal';
import { useTranslation } from 'react-i18next';

const Process = () => {
  const { t } = useTranslation();
  const steps = t('process.steps', { returnObjects: true });

  return (
    <section className='px-6 py-10 bg-white md:py-10 md:px-8'>
      <div className='max-w-6xl mx-auto'>
        {/* HEADER */}

        <ScrollReveal>
          <div className='max-w-xl mb-20 md:mb-24'>
            <p
              className='
              text-[#2F8F6F]
              uppercase
              tracking-[0.25em]
              text-[11px]
              mb-5
              font-medium
              '
            >
              {t('process.label')}
            </p>

            <h2
              className='
              font-semibold
              mb-5
              text-[36px]
              sm:text-[44px]
              md:text-[52px]
              leading-tight
              tracking-tight
              '
            >
              {t('process.title')}
            </h2>

            <p className='text-sm leading-relaxed text-neutral-600 md:text-base'>
              {t('process.desc')}
            </p>
          </div>
        </ScrollReveal>

        {/* FLOW */}

        <div className='relative'>
          {/* desktop line */}

          <div className='absolute left-0 hidden w-full h-px md:block top-8 bg-gradient-to-r from-neutral-200 via-neutral-300 to-neutral-200' />

          <div className='relative grid grid-cols-1 gap-12 md:grid-cols-4 md:gap-14'>
            {steps.map((step, i) => (
              <ScrollReveal key={step.title} delay={i * 0.1}>
                <div className='flex flex-col items-center text-center group'>
                  {/* NODE */}

                  <div
                    className='
                    relative
                    w-14
                    h-14
                    rounded-full
                    bg-white
                    border
                    border-neutral-200
                    flex
                    items-center
                    justify-center
                    text-xl
                    shadow-sm
                    transition
                    duration-300
                    group-hover:-translate-y-1
                    group-hover:shadow-md
                    group-hover:border-[#2F8F6F]
                    '
                  >
                    {step.icon}

                    {/* subtle glow */}

                    <div
                      className='
                      absolute
                      inset-0
                      rounded-full
                      opacity-0
                      transition
                      group-hover:opacity-100
                      bg-[#2F8F6F]/5
                      '
                    />
                  </div>

                  {/* STEP NUMBER */}

                  <p
                    className='
                    text-[11px]
                    tracking-widest
                    text-neutral-400
                    mt-5
                    font-medium
                    '
                  >
                    STEP {String(i + 1).padStart(2, '0')}
                  </p>

                  {/* TITLE */}

                  <h3 className='mt-2 text-lg font-semibold tracking-tight md:text-xl'>
                    {step.title}
                  </h3>

                  {/* DESC */}

                  <p
                    className='
                    text-neutral-600
                    text-sm
                    mt-3
                    max-w-[240px]
                    leading-relaxed
                    '
                  >
                    {step.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
